import { render, staticRenderFns } from "./BaseAddress.vue?vue&type=template&id=20178948&"
import script from "./BaseAddress.vue?vue&type=script&lang=js&"
export * from "./BaseAddress.vue?vue&type=script&lang=js&"
import style0 from "./BaseAddress.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports